import { Component, OnInit, Inject } from '@angular/core';
import * as moment_ from 'moment';
import { constants } from "src/app/shared/common/contants";
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorMessages } from "../../shared/common/errormessages"
import { NgxUiLoaderService } from "ngx-ui-loader";
import { CommonService } from "src/app/shared/services/common.service";
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { AddSchedulerReportsComponent } from '../add-scheduler-reports/add-scheduler-reports.component';
import { Schedulebutton } from 'src/app/shared/common/Schedulebutton';
import { VeevareportingComponent } from '../veevareporting/veevareporting.component';
const moment = moment_;


@Component({
    selector: 'app-scheduler-reports',
    templateUrl: './scheduler-reports.component.html',
    styleUrls: ['./scheduler-reports.component.scss'],
    standalone: false
})
export class SchedulerReportsComponent implements OnInit {

  value;
  gridAPI;
  lastPage;
  currentPage;
  nextPage;
  nextPagePlusOne;
  totalPages;
  gridColumnAPI;
  columnDefs;
  rowData;
  rowClassRules;
  defaultColDef;
  rowSelection;
  paginationPageSize;
  paginationNumberFormatter;
  pageSize;
  components: any;
  overlayNoRowsTemplate;
  buttonName;
  scheduleReportData: any = [];
  getdata: any;
  validation_messages:any
  endDateTemp: any = moment(null)
  today = new Date()
  startDatetemp: any = moment(null)
  backgroundColorScreen = "";
  backgroundColorButton = "";

  concreteUpdateReportData = {
    "materialcategoryid": "",
    "date": ""
  }

  //constructor
  constructor(
    private constants: constants,
    private dialog: MatDialog,
    private service: CommonService,
    private spinner: NgxUiLoaderService,
    private snackbar: MatSnackBar,
    private errorMsg: ErrorMessages,
    private localStorageSettings: LocalStorageSettingsService,
  ) {
    this.validation_messages = this.errorMsg.concreteUpdateReportMessages;
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Schedulebutton,
    }
    //if no rows , this message will display
    this.overlayNoRowsTemplate = this.constants.Norows;
  }

  ngOnInit() {
    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

     this.columnDefs = [
      {headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      cellRendererParams: {
        edit: this.editIcon.bind(this),
        delete: this.deleteIcon.bind(this),
        addfilter: this.filterIcon.bind(this),
        addschedule: this.scheduleIcon.bind(this),
      },
      pinned:'left',
      lockPinned: true,
      width: 210
    },
      { headerName: 'Report Name', headerTooltip: 'Report Name', tooltipValueGetter: (params) => 'Report Name: ' + params.value, field: 'reportname', filter: 'agTextColumnFilter', width: 180 },   
      { headerName: 'Report Type', headerTooltip: 'Report Type', tooltipValueGetter: (params) => 'Report Type: ' + params.value, field: 'reporttypename', filter: 'agTextColumnFilter', width: 180 },   
      { headerName: 'Report Reference', headerTooltip: 'Report Reference', tooltipValueGetter: (params) => 'Report Reference: ' + params.value, field: 'reportreferencename', filter: 'agTextColumnFilter', width: 180 },   
      { headerName: 'Products', headerTooltip: 'Products', tooltipValueGetter: (params) => 'Products : ' + params.value, field: 'productname', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Authorities', headerTooltip: 'Authorities', tooltipValueGetter: (params) => 'Authorities : ' + params.value, field: 'authoritiesname', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Schedule Frequency', headerTooltip: 'Schedule Frequency', tooltipValueGetter: (params) => 'Schedule Frequency : ' + params.value, field: 'date', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Day of The (week/month)', headerTooltip: 'Day of The (week/month)', tooltipValueGetter: (params) => 'Day of The (week/month) : ' + params.value, field: 'startdate', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Schedule Time', headerTooltip: 'Schedule Time', tooltipValueGetter: (params) => 'Schedule Time : ' + params.value, field: 'scheduletime', filter: 'agTextColumnFilter', width: 180 },
      { headerName: 'Run State', headerTooltip: 'Run State', tooltipValueGetter: (params) => 'Run State : ' + params.value, field: 'runstate', filter: 'agTextColumnFilter', width: 180,
        cellStyle: function(params) {
          if(params.value == "stop"){
            return {color: 'red', textAlign: 'center'};
          }else if(params.value == "start"){
            return {color: 'green', textAlign: 'center'};
          }
        },
          cellRenderer: function(params) {
          if(params.value == "stop"){
          return '<span><i class="material-icons">stop</i></span>'
          }else if(params.value == "start"){
            return '<span><i class="material-icons">play_arrow</i></span>'
          }
        }
      },
     { headerName: 'Last Run Date & Time', headerTooltip: 'Last Run Date & Time', tooltipValueGetter: (params) => 'Last Run Date & Time : ' + params.value, field: 'matreqdateandtime', filter: 'agTextColumnFilter', width: 180 },
  ]

    // if the record has status==no , row color will change
    this.rowClassRules = {
      'rowBackgroundColor': function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };

    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };

    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };

  }

  //excel export function
  onBtExport() {
    this.gridAPI.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1
      this.nextPagePlusOne = this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1
      this.totalPages = this.gridAPI.paginationGetTotalPages()
    }
  }

  //this function is for going to the given page number 
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;
    this.gridAPI.setGridOption('paginationPageSize', Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    console.log("next")
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    console.log("previous")
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }
  //pagination code ends

  // below function is to load the ag grid
  onGridReady(params) {
    let res: any
    this.gridAPI = params.api;
    this.gridColumnAPI = params.columnApi;
    this.gridAPI.setGridOption('rowData', []);
  }

  onRowDoubleClick(e) {
    console.log(e);
    console.log(e.data)

     var obj = {
        "reportname":e.data.reportname,
        "reporttypeid":e.data.reporttypeid,
        "reportreferenceid":e.data.reportreferenceid,
        "productid":e.data.productid,
        "authoritiesid":e.data.authoritiesid,
        "date":e.data.date,
        "scheduletime":e.data.scheduletime,
        "startdate":e.data.startdate,
        "enddate":e.data.enddate
     }

    let dialogRef = this.dialog.open(AddSchedulerReportsComponent, {panelClass: 'custom-dialog-container-materialFulfilment',
      width: "50%",
      height: "85vh",
      data: { edata: obj},
      disableClose: true,
        });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        console.log("If condition")
        // this.concreteService.updateConcreteData(result).subscribe(response=>
        //   { 
        //     console.log(response);
        //     if(response.error == true){
        //       this.snackbar.open(response.statusMessage, "OK" ,{
        //         duration: 5000,
        //       });
        //     }else if(response.error == false){
        //     this.snackbar.open(response.message, "OK", {
        //       duration: 5000,
        //     });          
        //     this.senddata();
        //   }
        //  });
        }
        })
      
  }

  
  schedulerReportPopup(){
    let dialogRef = this.dialog.open(AddSchedulerReportsComponent, {panelClass: 'custom-dialog-container-materialFulfilment',
    width: "50%",
    height: "85vh",
    autoFocus : false,
    data : {},
       disableClose: true,
        });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        console.log("If condition")
        this.scheduleReportData.push(result);
        console.log(this.scheduleReportData)
        this.gridAPI.setGridOption('rowData', this.scheduleReportData);
        }
      });  
    }

  deleteIcon(e){
    console.log(e.rowData)
    if (confirm("Are you sure you want to delete the record ?") == true) {
      // this.concreteService.deleteBatchPlant(e.rowData).subscribe(response =>{
      //   console.log(response)
      //   if(response.error){
      //     this.snackbar.open(response.statusMessage, "OK", {
      //       duration: 5000,
      //      });
      //     }else{
      //     this.snackbar.open(response.statusMessage, "OK", {
      //        duration: 5000,
      //       });
      //       this.retrievebpservice();
      //     }
      // },error=>{
      //   this.snackbar.open("Please check your connection.", "OK", {
      //     duration: 5000,
      //    });
      // })
    }
 
  }

  editIcon(e){
    console.log(e);
    console.log(e.rowData)
    var obj = {
      "reportname":e.rowData.reportname,
      "reporttypeid":e.rowData.reporttypeid,
      "reportreferenceid":e.rowData.reportreferenceid,
      "productid":e.rowData.productid,
      "authoritiesid":e.rowData.authoritiesid,
      "date":e.rowData.date,
      "scheduletime":e.rowData.scheduletime,
      "startdate":e.rowData.startdate,
      "enddate":e.rowData.enddate
   }

  let dialogRef = this.dialog.open(AddSchedulerReportsComponent, {panelClass: 'custom-dialog-container-materialFulfilment',
    width: "50%",
    height: "85vh",
    data: { edata: obj},
    disableClose: true,
      });

  // subcribe the popup after close
  dialogRef.afterClosed().subscribe(result => {
    console.log(result);
    if (result != undefined) {
      console.log("If condition")
      // this.concreteService.updateConcreteData(result).subscribe(response=>
      //   { 
      //     console.log(response);
      //     if(response.error == true){
      //       this.snackbar.open(response.statusMessage, "OK" ,{
      //         duration: 5000,
      //       });
      //     }else if(response.error == false){
      //     this.snackbar.open(response.message, "OK", {
      //       duration: 5000,
      //     });          
      //     this.senddata();
      //   }
      //  });
      }
      })

}

filterIcon(e){
  console.log(e);
  console.log(e.rowData)
  let dialogRef = this.dialog.open(VeevareportingComponent, {panelClass: 'custom-dialog-container-materialFulfilment',
  width: "80%",
    data: {},
    disableClose: true,
      });

  // subcribe the popup after close
  dialogRef.afterClosed().subscribe(result => {
    console.log(result);
    if (result != undefined) {     
      }
      })
}

scheduleIcon(e){
  console.log(e);
  console.log(e.rowData)
}

}
